// Copyright (c) 2018 Swashata Ghosh <swashata@wpquark.com>
//
// This software is released under the MIT License.
// https://opensource.org/licenses/MIT
// Just a wrapper for main entry

// Import main component
import FontIconPicker from './components/FontIconPicker';

// And export it... man it does too much work
export default FontIconPicker;
